<ul class="sidebar navbar-nav toggled">
    <li class="nav-item">
        <a class="nav-link" routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
            <i class="fas fa-fw fa-home"></i>
            <span i18n="@@Home | Navigation Home Button">Home</span>
        </a>
    </li>
    <li *ngIf="isWoohoo" class="nav-item">
        <a data-toggle="modal" data-target="#woohooModal" class="howToWIN nav-link pulsate" routerLink="" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
            <i class="fas fa-fw fa-award"></i>
            <span>Earn More Entries!</span>
        </a>
    </li>
    <li *ngIf="isWoohoo" class="nav-item">
        <a class="winners nav-link" href="https://www.woohoo365.co.za/winners/" target="blank" routerLinkActive="active-link">
            <i class="fas fa-fw fa-trophy"></i>
            <span>Winners</span>
        </a>
    </li>
    <li *ngIf="!singleChannel && !singleChannelMultiPlay" class="nav-item ">
        <a class="nav-link" routerLink="/channels" routerLinkActive="active-link">
            <i class="fas fa-fw fa-eye"></i>
            <span i18n="@@My Channels | My Channels Dropdown Title">Explore Channels</span>
        </a>
    </li>

    <!-- <li class="nav-item ">
            <a class="nav-link" routerLink="/my-subscriptions" routerLinkActive="active-link">
                <i class="fas fa-star"></i>
                <span i18n="@@Subscriptions | Navigation Subscriptions Button">Subscriptions</span>
            </a>
        </li> -->
    
    
    <li class="nav-item">
            <a class="nav-link" routerLink="/my-list" routerLinkActive="active-link">
                <i class="fas fa-fw fa-list"></i>
                <span i18n="@@My List | Navigation My List Button">My List</span>
            </a>
        </li>
    <li class="nav-item">
        <a class="nav-link" routerLink="/watch-history" routerLinkActive="active-link">
            <i class="fas fa-fw fa-history"></i>
            <span i18n="@@Viewing History | Navigation Viewing History Button" >Viewing History</span>
        </a>
    </li>
    <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/edit-subscriptions" routerLinkActive="active-link">

            <i class="fas fa-fw fa-pen"></i>
            <span i18n="@@Nav Edit Subs">Edit Subscriptions</span>
        </a>
    </li> -->
    <li class="nav-item">
        <a class="nav-link" routerLink="/account" routerLinkActive="active-link">

            <i class="fas fa-fw fa-user-circle"></i>
            <span i18n="@@Account Details | Navigation Account Details Button">Account Details</span>
        </a>
    </li>
    <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/edit-account" routerLinkActive="active-link">
            <i class="fas fa-fw fa-edit"></i>
            <span i18n="@@Edit Account | Navigation Edit Account Button">Edit Account</span>
        </a>
    </li> -->
    <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/kidstubeut" routerLinkActive="active-link">
            <i class="fas fa-fw fa-sign-out-alt"></i>
            <span i18n="@@Logout | Navigation Logout Button">Logout</span>
        </a>
    </li> -->
    <li class="nav-item">
           <br><br><br>
        </li>
         </ul>
             <!-- Woohoo How it Works Modal-->
    <div class="modal fade" id="woohooModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2>WIN WITH WOOHOO 365</h2>
                    <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                             <div class="row">
                            <div class="col-md-6">
                            <h3>DAILY LUCKY PRIZE DRAW</h3>
                           <h4>All subscribers are automatically entered into the daily prize draw</h4>
                           <h5>A total of R1000 in cash is up for grabs daily</h5>
                           <br/><h3>1st Prize: R500 Cash</h3>
                           <br/><h3>2nd Prize: R200 Cash</h3>
                           <br/><h3>3rd Prize: R200 Cash</h3>
                           <br/><h3>4th Prize: R100 Cash</h3>
                           <br/><p>Subscribers receive additional Free Entries into the draw for every 5 minutes that they play games for, or for every time they play new games on the platform
                          </p><p>Prize draws take place every day at 00h00 midnight
                          <p>Prize winners are posted on the WooHoo Facebook page every morning at 09h00
                        </p>
<button data-dismiss="modal" aria-label="Close" routerLink="/" type="button" class="form-control">
    <span>Play Now</span>
  </button>
                  
                </div>
            </div>
        </div>
    </div>

